import { Hatch } from "./classes/Hatch";
import NotificationCenter from "./components/Notification";
import Tooltip from "./components/Tooltip";
import Code from "./components/Code";
import HelpHandler from "./components/HelpHandler";
import Utils from "./classes/Utils";
import { ToggleableElement } from "./global/interfaces";
import { MitreModal } from "./components/MitreModal";
import { bigDropzone } from "./components/BigDropzone";
import { Section } from "./components/Section";

// DOMReady
// intialize pre-existent tooltips
document.querySelectorAll("[data-tooltip]:not(.custom-tooltip)").forEach((el) => {
  new Tooltip({
    target: el,
    text: el.getAttribute("data-tooltip"),
    position: "bottom",
  });
});

const dtOptions: Parameters<typeof Intl.DateTimeFormat>[1] = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "UTC",
  timeZoneName: "short",
};

const UKDateTimeFormat = new Intl.DateTimeFormat("en-UK", dtOptions);

document.querySelectorAll("[h-datetime]").forEach((el) => {
  const date = new Date(el.getAttribute("h-datetime"));
  if (!date) {
    return;
  }
  el.textContent = UKDateTimeFormat.format(date);
});

document.querySelectorAll("[h-date]").forEach((el) => {
  const date = new Date(el.getAttribute("h-date"));
  if (!date) {
    return;
  }
  el.textContent = date.toLocaleDateString("en-UK", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "UTC",
  });
});

document.querySelectorAll("[data-modal-ttp]").forEach((item) => {
  let ttp = item.getAttribute("data-modal-ttp");
  item.addEventListener("click", (e) => {
    e.preventDefault();
    new MitreModal(ttp);
  });

  item.addEventListener("mouseenter", () => {
    document.querySelectorAll("[data-modal-ttp]").forEach((item) => {
      if (item.getAttribute("data-modal-ttp") === ttp) {
        item.classList.add("hover");
      }
    });
  });

  item.addEventListener("mouseleave", () => {
    document.querySelectorAll("[data-modal-ttp]").forEach((item) => {
      if (item.getAttribute("data-modal-ttp") === ttp) {
        item.classList.remove("hover");
      }
    });
  });
});

document.querySelectorAll("[data-close-toast]").forEach((item) => {
  item.addEventListener("click", (e: Event) => {
    e.preventDefault();
    let toast = item.closest(".toast");
    Utils.closeToast(toast as HTMLElement);
  });
});

globalThis.notification = new NotificationCenter({
  parent: document.querySelector("#notification-center"),
  list: document.querySelector(".page-header .notifications__list"),
});

if (document.querySelector("[data-toggle-notifications]")) {
  document.querySelector("[data-toggle-notifications]").addEventListener("click", (e) => {
    e.preventDefault();
    document.querySelector(".page-header .notifications__list").classList.toggle("open");

    let menu = document.querySelector("nav .menu");
    if (!document.querySelector(".page-header .notifications__list").classList.contains("hidden")) {
      menu.classList.add("hidden");
    }
  });
}

// Search field focus/blur
let field = document.querySelector<HTMLInputElement>('.main-nav input[type="search"]');
let menuItems = document.querySelectorAll(".main-nav__secondary li > *");

if (field) {
  let navWidth = document.querySelector(".main-nav__secondary").getBoundingClientRect().width;
  let fieldWidth = field.getBoundingClientRect().width;
  field.addEventListener("focus", () => {
    menuItems.forEach((item) => {
      if (item.classList.contains("search")) return;
      item.parentElement.classList.add("hidden");
    });
    field.style.width = navWidth + 0 + "px";
  });

  field.addEventListener("blur", () => {
    if (!field.value) {
      menuItems.forEach((item) => {
        item.parentElement.classList.remove("hidden");
      });
      field.style.width = fieldWidth + "px";
    }
  });
}
// initialize code
document.querySelectorAll("[data-code]").forEach((el: HTMLElement) => new Code(el));

document.querySelectorAll(".tab-view__bar").forEach((e) => {
  initScrollTabBar(e);
});

// initialize Collapsing Windows
document.querySelectorAll("[data-section]").forEach((el) => new Section(el as HTMLElement));

if (document.querySelector("#toggleHeaderMenu")) {
  document.querySelector("#toggleHeaderMenu").addEventListener("click", () => {
    let menu = document.querySelector("nav .menu");
    if (menu.classList.contains("hidden")) document.querySelector(".notifications__list").classList.remove("open");
    menu.classList.toggle("hidden");
  });
}

function initScrollTabBar(el: Element) {
  let scrollbar = el;
  if (Utils.getOverflow(scrollbar).isOverflow) {
    if (scrollbar.parentElement) {
      scrollbar.parentElement.classList.add("left");
      scrollbar.classList.add("overflown");
    }
  }

  scrollbar.addEventListener("scroll", () => {
    let overflow = Utils.getOverflow(scrollbar);

    if (overflow.isOverflow) {
      scrollbar.classList.add("overflown");
      scrollbar.parentElement.classList.remove("both");
      scrollbar.parentElement.classList.remove("left");
      scrollbar.parentElement.classList.remove("right");
      scrollbar.parentElement.classList.add(overflow.dir);
    }
  });
}

document.querySelectorAll("#feedback, [data-leave-feedback]").forEach((el) =>
  el.addEventListener("click", (ev) => {
    ev.preventDefault();
    Utils.feedback();
  })
);

function setPrint() {
  const closePrint = () => {
    document.body.removeChild(this);
  };
  this.contentWindow.onbeforeunload = closePrint;
  this.contentWindow.onafterprint = closePrint;
  this.contentWindow.print();
}

document.querySelector(".print-to-pdf[data-print-url]")?.addEventListener("click", function () {
  const hideFrame = document.createElement("iframe");
  hideFrame.referrerPolicy = "no-referrer";
  hideFrame.setAttribute("sandbox", "allow-same-origin allow-modals");
  hideFrame.onload = setPrint;
  hideFrame.style.display = "none"; // hide iframe
  hideFrame.src = this.getAttribute("data-print-url");
  document.body.appendChild(hideFrame);
});

document.querySelectorAll("[data-clipboard]").forEach((item) => {
  item.addEventListener("click", () => {
    Utils.copyToClipboard(item);
  });
});

if (document.querySelectorAll("[data-show-more]")) {
  document.querySelectorAll("[data-show-more]").forEach((item) => {
    item.addEventListener("click", () => {
      Utils.toggleShowMore(item as ToggleableElement);
    });
  });
}

let toggleAPI = document.querySelector("#toggleAPI");
toggleAPI?.addEventListener("click", () => {
  let field = <HTMLInputElement>document.querySelector("#userapikey");
  if (field.getAttribute("type") === "text") {
    field.setAttribute("type", "password");
    toggleAPI.innerHTML = "Show API Key";
  } else {
    field.setAttribute("type", "text");
    toggleAPI.innerHTML = "Hide API Key";
  }
});

document.querySelectorAll("[data-help-toggle]").forEach((item) => {
  new HelpHandler(item as HTMLElement);
});

// initialize tasksbar elements
if (document.querySelector(".report-tasks")) {
  let el = document.querySelector(".report-tasks");
  let but = el?.querySelector("#toggle-tasks");

  but?.addEventListener("click", () => {
    if (el?.classList.contains("folded")) {
      el.classList.remove("folded");
      localStorage.setItem("tasks-folded", "false");
      document.cookie = "menu-folded=false";
    } else {
      el?.classList.add("folded");
      localStorage.setItem("tasks-folded", "true");
      document.cookie = "menu-folded=true";
    }
  });
}
document.querySelectorAll(".block.expandable h4").forEach((block) => {
  block.addEventListener("click", () => {
    block.parentElement.classList.toggle("expanded");
  });
});

if (localStorage.getItem("allow-cookies") !== "true" && !globalThis.user && globalThis.isPublic) {
  let el = document.createElement("div");
  el.classList.add("toast", "info", "cookie-banner", "article");
  setTimeout(() => {
    el.classList.add("up");
  }, 10);

  el.innerHTML = Hatch`
    <h3>We care about your privacy.</h3>
    <p>This website stores cookies on your computer. These cookies are used to improve your website experience and provide more personalized services to you, both on this website and through other media. To find out more about the cookies we use, see our <a href="/policy" target="_blank">Privacy Policy</a>.</p>
    <div class="button-bar">
      <button class="button primary">Accept</button>
    </div>
  `.toString();

  document.body.appendChild(el);
  el.querySelector("button").addEventListener("click", () => {
    localStorage.setItem("allow-cookies", "true");
    // initGA();
    el.classList.remove("up");
    setTimeout(() => {
      el.remove();
    }, 300);
  });
} else {
  if (globalThis.isPublic) {
    // initGA();
  }
}

let menuEl = document.querySelector("#toggle_menu");

menuEl?.addEventListener("click", () => {
  menuEl.classList.toggle("toggled");
  document.querySelector(".main-nav").classList.toggle("shown");
});

// Enable fullscreen dropper on predefined routes
if (["/dashboard", "/submit/file"].includes(window.location.pathname)) {
  if (globalThis.permissions.includes("submit_samples")) {
    new bigDropzone();
  }
}
